import * as Yup from "yup";

export const preApplicationSchema = [
  Yup.object({
    isInternationalStudent: Yup.string().required(
      "Please indicate if you are applying as an international student."
    ),
    primaryReasonForStudying: Yup.string().required(
      "Please select your primary reason for studying."
    ),
  }),
  Yup.object({
    understandsFinancialCosts: Yup.string().required(
      "Please indicate if you understand the tuition and living cost requirements."
    ),
    estimatedAnnualLivingCost: Yup.string().required(
      "Please select your estimated annual living cost."
    ),
    fundingSource: Yup.string().required(
      "Please select how you plan to fund your studies."
    ),
    workStudyExpectation: Yup.string().required(
      "Please select your expectation about working while studying."
    ),
  }),
  Yup.object({
    understandsVisaRequirements: Yup.string().required(
      "Please indicate if you understand the Student visa requirements."
    ),
    understandsVisaIsTemporary: Yup.string().required(
      "Please indicate if you understand the Student visa is temporary."
    ),
    confirmsGenuineIntention: Yup.string().required(
      "Please confirm your genuine intention to study."
    ),
  }),
];
